import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { useUserStore } from "base/stores";

import { Chip, CHIP_SIZES, OverflowText } from "../../datadisplay/index.jsx";
import { UserIcon } from "../usericon/index.jsx";
import {
  ICON_SIZE,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./userchip.css";

/**
 * User chip will display user name with icon and close icon
 */

export function UserChip(props) {
  const {
    userId,
    onClick,
    onClose,
    name,
    disabled = false,
    size = CHIP_SIZES.MEDIUM,
    iconName = "",
    className,
    accountId
  } = props;
  const users = useUserStore.getState().users || {};
  const user = users[userId];
  return (
    <Chip
      onClick={onClick}
      onClose={onClose}
      disabled={disabled}
      size={size}
      icon={
        iconName ? (
          <KfIcon icon={iconName} size={ICON_SIZE.SIZE_20} />
        ) : (
          <UserIcon
            className={styles.profileImage}
            userId={userId}
            name={name}
            accountId={accountId}
          />
        )
      }
    >
      <div className={`${className}`}>
        <OverflowText>{name || (user && user.Name)}</OverflowText>
      </div>
    </Chip>
  );
}

UserChip.propTypes = {
  /** Id for user */
  userId: PropTypes.string,
  /** Function Called when clicks the chip */
  onClick: PropTypes.func,
  /**  Function called when click the close icon of chip */
  onClose: PropTypes.func,
  /** Name of the user */
  name: PropTypes.string,
  /** Disables the chip */
  disabled: PropTypes.bool,
  /** Variantion in the size of the chip */
  size: PropTypes.oneOf(Object.values(CHIP_SIZES)),
  /** iconName to show a particular icon */
  iconName: PropTypes.string,
  /**
   * Custom classname to customize the userChip
   */
  className: PropTypes.string,
  /**
   * To get sandbox user profile asset
   */
  accountId: PropTypes.string
};

UserChip.defaultProps = {
  userId: "",
  name: "",
  disabled: false,
  onClick: () => {}
};
